import { render, staticRenderFns } from "./WorkflowIcon.vue?vue&type=template&id=04ebf9b2&"
import script from "./WorkflowIcon.vue?vue&type=script&lang=js&"
export * from "./WorkflowIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports